import EpgPersistence from "../../../AAF/Nepg/EpgPersistence";
import AbstractRequestTask from "../AbstractRequestTask";

class keyAktSeedTask extends AbstractRequestTask{
    constructor(url = '') {
        super();
        this.params = super.getParams();
        this.user_token = this.params.user_token;
        this.url = url;
    }

    getUrl() {
        return this.url;
    }

    getParams() {
        const params = super.getParams();
        delete params.format
        delete params.api_version
        delete params.user_token
        delete params.HKS
        delete params.device_id
        delete params.device_name
        delete params.device_so
        delete params.user_id

        return {
            ...params,
            timezoneOffset: EpgPersistence.getOffset() / 60
        };
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

     getMethod() {
        return 'GET';
    }

     isValid(){
        return true
    }
}

export default keyAktSeedTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/keyAktSeedTask.js